import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


import { Moneda } from '../../model/moneda';
import { Consorcio } from '../../model/consorcio';
import { CatalogoServicios } from '../../model/catalogo-servicios';


import { CatalogoServiciosService } from '../../services/catalogo-servicios.service';
import { MonedaService } from '../../services/moneda.service';


@Component({
  selector: 'app-catalogo-servicios-mantenimiento',
  templateUrl: './catalogo-servicios-mantenimiento.component.html',
  styleUrls: ['./catalogo-servicios-mantenimiento.component.css']
})
export class CatalogoServiciosMantenimientoComponent implements OnInit {

  @Input() servicioSeleccionado: CatalogoServicios;
  @Input() consorcio: Consorcio;
  @Output() onReturn = new EventEmitter();


  public servicio: CatalogoServicios = new CatalogoServicios();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public monedas: Moneda[];


  constructor(
    private _monedaService: MonedaService,
    private _servicioService: CatalogoServiciosService

  ) { }

  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this._monedaService.getMonedas()
      .subscribe(
      monedas => this.monedas = monedas,
      err => {
        console.log(err);
      });

    if (this.servicioSeleccionado.id != undefined) {
      this.servicio = this.servicioSeleccionado;
      this.estadoEditar = true;
    }

  }

  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }
  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  /* Fin navegación */
  onSubmitSuccess(data: any) {
    this.regresar();
  }

  onSubmit() {

    this.servicio.codigoConsorcio = this.consorcio.codigoConsorcio;
    if (this.servicio.id === undefined) {
      this.servicio.id = 0;
    }
    this._servicioService.insert(this.servicio).subscribe(
      result => { 
        if(result.Resultado === "codigoServicio ya existe en la base de datos"){
            alert("El código del Servicio ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  borrarRegistro() {
    this._servicioService.delete(this.servicio).subscribe(
      result => this.regresar(),
      err => {
        console.log(err._body);
      });
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/catalogo-servicios-mantenimiento/catalogo-servicios-mantenimiento.component.ts